export const GET_RECENT_PLANS = "recentPlans/GET_RECENT_PLANS";